import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";

const ConfirmationDialog = ({open, onClose}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>
                Potwierdzenie
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    Na podany adres email zostały link weryfikujący do resetowania hasła. Proszę sprawdzić skrzynkę email.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                >
                    Zamknij
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmationDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func
};

export default ConfirmationDialog;
